import { Sparkles, Facebook, Instagram } from 'lucide-react';
import { Link } from 'react-router-dom';
import Button from './ui/Button.jsx';
import { useLocale } from '../hooks/useLocale.js';

const socialLinks = [
  { icon: Facebook, name: 'Facebook', url: 'https://www.facebook.com/NorthernLightsSolution' },
  { icon: Instagram, name: 'Instagram', url: 'https://www.instagram.com/northernlightsolution' },
];

const Footer = () => {
  const { t, interpolate } = useLocale();

  return (
    <footer className="bg-gradient-to-b from-slate-900 via-slate-800 to-black text-white relative overflow-hidden">
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-0 left-1/4 w-96 h-96 bg-emerald-500 rounded-full mix-blend-multiply filter blur-3xl animate-blob"></div>
        <div className="absolute top-0 right-1/4 w-96 h-96 bg-purple-500 rounded-full mix-blend-multiply filter blur-3xl animate-blob-reverse"></div>
      </div>
      <div className="container relative mx-auto px-4 sm:px-6 lg:px-8 py-24">
        <div className="text-center mb-16">
            <h2 className="text-5xl md:text-6xl font-black text-transparent bg-clip-text bg-gradient-to-r from-emerald-300 via-cyan-300 to-blue-300 mb-8 font-['Montserrat',sans-serif] tracking-tight">{t('footer.heading')}</h2>
            <div className="mt-10">
                <Link to="/books">
                  <Button size="lg" variant="tertiary">
                    <Sparkles size={20} />
                    {t('footer.button')}
                  </Button>
                </Link>
            </div>
        </div>
        {/* Social Media Links */}
        <div className="flex justify-center gap-4 mt-12 mb-8">
          {socialLinks.map((social, index) => {
            const Icon = social.icon;
            return (
              <a
                key={index}
                href={social.url}
                target="_blank"
                rel="noopener noreferrer"
                aria-label={`Follow us on ${social.name}`}
                className="p-3 rounded-full bg-white/10 hover:bg-emerald-500 transition-all duration-300 hover:-translate-y-1 hover:shadow-lg"
              >
                <Icon size={20} className="text-white" />
              </a>
            );
          })}
        </div>

        <div className="mt-8 border-t border-white/10 pt-12 flex flex-col md:flex-row justify-between items-center text-center md:text-left">
          <p className="text-gray-400 font-semibold font-['Poppins',sans-serif]">{interpolate(t('footer.copyright'), { year: new Date().getFullYear() })}</p>
          <div className="flex space-x-6 mt-6 md:mt-0">
            <Link to="/book-resources" className="text-gray-400 hover:text-emerald-400 font-semibold transition-colors font-['Poppins',sans-serif]">Teaching Resources</Link>
            <Link to="/privacy" className="text-gray-400 hover:text-emerald-400 font-semibold transition-colors font-['Poppins',sans-serif]">{t('footer.privacy')}</Link>
            <Link to="/terms" className="text-gray-400 hover:text-emerald-400 font-semibold transition-colors font-['Poppins',sans-serif]">{t('footer.terms')}</Link>
            <Link to="/contact" className="text-gray-400 hover:text-emerald-400 font-semibold transition-colors font-['Poppins',sans-serif]">{t('footer.contact')}</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;